/* ============================================================
   Global produktside (pv27) — klient-adfærd, september 2026.

   Kører OVENPÅ temaets eksisterende motorer og erstatter dem ikke:
     - Variant-vælgeren er temaets NORMALE picker (color-swatches
       type:'detail' → variant-radios-detail). Klik, pris, lager,
       URL og "Valgt:"-tekst hører helt til theme.js. Denne fil
       PYNTER kun temaets egne <label>-elementer (farveflade, undertekst,
       flueben) og reagerer på det færdige resultat (section 'change').
     - Mængderabat er discount-tiers.js (uændret, loades betinget).
   Se docs/GLOBAL_PRODUKTSIDE_2026_09.md.
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('.pv27');
  if (!section) return;

  var mainForm = section.querySelector('form[id^="product-form-"]');

  /* ── Hjælpere ── */
  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt =
        (window.themeGlobalVariables && window.themeGlobalVariables.settings && window.themeGlobalVariables.settings.money_format) ||
        (window.cartStrings && window.cartStrings.money_format);
      if (fmt) return window.Shopify.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }
  function shortMoney(cents) { return money(cents).split(',00').join(''); }

  var productData = null;
  function getProduct() {
    if (productData) return productData;
    var el = section.querySelector('.productJson, [data-product-json]');
    if (!el) return null;
    try { productData = JSON.parse(el.textContent); } catch (e) { return null; }
    return productData;
  }

  function currentVariantId() {
    var input = mainForm && mainForm.querySelector('input[name="id"]');
    var id = input ? parseInt(input.value, 10) : NaN;
    if (!isNaN(id)) return id;
    var data = getProduct();
    if (data && data.variants && data.variants.length) return data.variants[0].id;
    return null;
  }

  function currentVariant() {
    var data = getProduct();
    var id = currentVariantId();
    if (!data || !data.variants || !id) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === id) return data.variants[i];
    }
    return null;
  }

  function currentQty() {
    var input = mainForm && (mainForm.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + mainForm.id + '"]'));
    var v = input ? parseInt(input.value, 10) : 1;
    return isNaN(v) || v < 1 ? 1 : v;
  }

  /* Option-værdier i resuméer: "Mellem - 150 mm" → lang "Mellem 150 mm" / kort
     "Mellem"; "Latte Brown - M" → "Latte Brown" (finish-koden er intern).
     Samme regel som Liquid'en i sektionen, så teksten ikke skifter efter load. */
  function valueLong(v) { return String(v || '').replace(/\s+-\s+[A-Za-z]$/, '').replace(/\s+-\s+/g, ' ').trim(); }
  function valueShort(v) { return String(v || '').replace(/\s+-\s+[A-Za-z]$/, '').split(/\s+-\s+/)[0].trim(); }

  function labelFor(input) {
    if (!input || !input.id) return null;
    var next = input.nextElementSibling;
    if (next && next.tagName === 'LABEL' && next.getAttribute('for') === input.id) return next;
    return section.querySelector('label[for="' + input.id + '"]');
  }
  /* Fyld til de SMÅ prikker ("Du ser", købsbar, kollapsede rækker).
     Liquid-kortet i sektionen sætter --pv27-dot til værdiens farve (også når
     swatch-feltet selv viser variantens foto, --pv27-sw) — et foto på
     16–22 px kan ikke læses. */
  function swatchFill(label) {
    if (!label) return '';
    var cs = getComputedStyle(label);
    var sw = cs.getPropertyValue('--pv27-dot').trim() || cs.getPropertyValue('--pv27-sw').trim();
    if (sw) return sw;
    var raw = (label.getAttribute('data-option-swatch-value') || '').trim();
    if (/^(rgb|#|hsl)/i.test(raw)) return raw;
    if (/^url\(/i.test(raw)) return raw + ' center / cover';
    return '';
  }

  /* Test-visning: temaets updateURL erstatter adressen med ?variant=… og
     taber ?view=global, så en genindlæsning ville vise standard-skabelonen.
     Kører efter pickerens egen change-handler (bobler op til sektionen). */
  (function keepViewParam() {
    var view = new URLSearchParams(window.location.search).get('view');
    if (!view || !window.history || !window.history.replaceState) return;
    section.addEventListener('change', function () {
      setTimeout(function () {
        var params = new URLSearchParams(window.location.search);
        if (params.get('view') === view) return;
        params.set('view', view);
        window.history.replaceState(window.history.state, '', window.location.pathname + '?' + params.toString() + window.location.hash);
      }, 0);
    });
  })();

  /* ── 1) Hero: medie-skift ved variantskift + thumbnails + mobil dots/swipe ── */
  (function initHeroMedia() {
    var mediaWrap = section.querySelector('[data-pv27-hero-main]');
    if (!mediaWrap) return;
    var slides = Array.prototype.slice.call(mediaWrap.querySelectorAll('[data-pv27-slide]'));
    if (!slides.length) return;
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-pv27-thumb]'));
    var moreBtn = section.querySelector('[data-pv27-thumb-more]');
    var dots = Array.prototype.slice.call(mediaWrap.querySelectorAll('.pv27-hero-dot'));
    var counterEl = mediaWrap.querySelector('[data-pv27-counter]');
    var current = -1;

    /* Skjulte slides bærer data-pv27-src/-srcset og får rigtig src første gang de vises */
    function hydrate(i) {
      var slide = slides[i];
      if (!slide) return;
      var img = slide.querySelector('img[data-pv27-src]');
      if (!img) return;
      var set = img.getAttribute('data-pv27-srcset');
      if (set) img.setAttribute('srcset', set);
      img.setAttribute('src', img.getAttribute('data-pv27-src'));
      img.removeAttribute('data-pv27-src');
      img.removeAttribute('data-pv27-srcset');
    }

    function indexOfMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) return i;
      }
      return -1;
    }

    function stopVideo(slide) {
      var player = slide.querySelector('.pv27-hero-video');
      if (player) player.parentNode.removeChild(player);
      slide.classList.remove('is-playing');
    }

    slides.forEach(function (slide) {
      var btn = slide.querySelector('[data-pv27-video-play]');
      var tpl = slide.querySelector('template[data-pv27-video]');
      if (!btn || !tpl) return;
      btn.addEventListener('click', function () {
        if (slide.querySelector('.pv27-hero-video')) return;
        slide.appendChild(tpl.content.cloneNode(true));
        slide.classList.add('is-playing');
        var vid = slide.querySelector('video.pv27-hero-video');
        if (vid && vid.play) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });

    function show(index, warmNeighbours) {
      if (index < 0 || index >= slides.length) return;
      hydrate(index);
      if (warmNeighbours) { hydrate(index + 1); hydrate(index - 1); }
      if (index === current) return;
      if (current >= 0 && slides[current]) stopVideo(slides[current]);
      current = index;
      var activeId = slides[index].getAttribute('data-media-id');
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-media-id') === activeId;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      if (counterEl) counterEl.textContent = (index + 1) + ' / ' + slides.length;
    }

    /* "+N": billederne ud over thumb-grænsen ligger allerede i DOM'en (skjult
       via .hidden) — klik afslører dem, i stedet for at cykle hero'en videre
       ét billede ad gangen uden nogen synlig/klikbar thumbnail for dem. */
    var extraThumbs = Array.prototype.slice.call(section.querySelectorAll('[data-pv27-thumb-extra]'));
    function revealExtras() {
      extraThumbs.forEach(function (t) { t.classList.remove('hidden'); });
      if (moreBtn) moreBtn.classList.add('hidden');
    }

    var initial = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    show(initial < 0 ? 0 : initial, false);
    if (thumbs[initial] && thumbs[initial].classList.contains('hidden')) revealExtras();

    thumbs.forEach(function (btn) {
      var idx = indexOfMedia(btn.getAttribute('data-media-id'));
      btn.addEventListener('pointerenter', function () { hydrate(idx); });
      btn.addEventListener('click', function () { show(idx, true); });
    });
    if (moreBtn) moreBtn.addEventListener('click', revealExtras);
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i, true); });
    });

    var touchStartX = null;
    mediaWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    mediaWrap.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(dx) < 40) return;
      var base = current < 0 ? 0 : current;
      show(dx < 0 ? base + 1 : base - 1, true);
    }, { passive: true });

    /* Variant uden eget foto → det billede der matcher FLEST af de valgte
       farver, med tidligere options vægtet højere (Krop slår Hjerte). ALDRIG
       et billede der matcher dårligere end det der allerede vises — en
       kombination uden noget matchende foto beholder simpelthen det
       nuværende billede i stedet for at hoppe til produktets hovedbillede
       (som ellers kunne vise en helt anden farvekombination, jf. bug fundet
       2026-09-17: Metalic Brun + Latte Brown-hjerte viste et Latte Brown-
       figur med RØDT hjerte). Samme vægt-regel køres server-side i
       sections/main-product-global.liquid ved sideindlæsning/reload, så de
       to aldrig er uenige. Pillen siger "Du ser" kun når fotoet ER den
       valgte variant, ellers "Dit valg". */
    function optionScore(a, b) {
      var n = a.options.length;
      var score = 0;
      for (var i = 0; i < n; i++) {
        if (a.options[i] === b.options[i]) score += 1 << (n - 1 - i);
      }
      return score;
    }
    var pillPrefix = section.querySelector('[data-pv27-viewing-prefix]');
    var labelSeen = section.getAttribute('data-pv27-viewing-label') || 'Du ser';
    section.addEventListener('change', function () {
      var v = currentVariant();
      if (!v) return;
      if (pillPrefix) pillPrefix.textContent = (v.featured_media ? labelSeen : 'Dit valg') + ': ';
      if (v.featured_media) {
        var idx = indexOfMedia(v.featured_media.id);
        if (idx >= 0) show(idx, false);
        return;
      }
      var data = getProduct();
      if (!data || !data.variants) return;
      var currentMediaId = current >= 0 && slides[current] ? slides[current].getAttribute('data-media-id') : null;
      var currentScore = 0;
      var bestIdx = -1;
      var bestScore = 0;
      for (var i = 0; i < data.variants.length; i++) {
        var candidate = data.variants[i];
        if (!candidate.featured_media) continue;
        var idx2 = indexOfMedia(candidate.featured_media.id);
        if (idx2 < 0) continue;
        var score = optionScore(v, candidate);
        if (currentMediaId && String(candidate.featured_media.id) === currentMediaId && score > currentScore) {
          currentScore = score;
        }
        if (score > bestScore) {
          bestScore = score;
          bestIdx = idx2;
        }
      }
      if (bestIdx >= 0 && bestScore > currentScore) show(bestIdx, false);
    });
  })();

  /* ── 2) Per-figur-rækker: ≥2 ÆGTE farve-options (samme slags valg, gentaget
        pr. figur/del) ⇒ collapsible rows ── */
  (function initRowsPattern() {
    var picker = section.querySelector('.pv27-variant-picker');
    if (!picker) return;
    /* Kun ÆGTE flerværdi-farve-options deltager i det kollapsible
       per-figur-mønster — en enkeltværdi-farve (fx "Topfarve" med kun én
       mulighed) skal ALTID vise den flade en-linje-række, uanset hvor mange
       andre farve-options produktet har. Uden dette filter fangede
       .pv27-picker--rows ALLE farve-fieldsets så snart der var ≥2 i alt,
       og klemte en enkeltværdi-swatch ned i den kollapsible CSS, hvor den
       ikke havde noget indhold at kollapse omkring (fundet ved
       live-test 2026-09-16: Sabre Agern, "2 · Vælg top farve").
       KRÆVER OGSÅ at option-navnet indeholder "farve"/"color"/"colour"
       (2026-09-25-fund): design-referencen for mønsteret er ægte per-figur/
       per-del FARVE-par (Sabre Romantisk Valentins Statue: "Vælg farve på
       stor" + "Vælg farve på lille", samme 13-farve-palet på begge — deraf
       "13 farver pr. figur" i hint-teksten nedenfor). Uden dette filter
       fangede mønsteret ETHVERT produkt med ≥2 uafhængige swatch-type
       options, uanset om de faktisk var farve-par — fundet på "Lampeskærm
       til Loopy Lamp" (loopy-hoved-lampeskaerm): "Vælg form" (3 værdier:
       Flad/Riflet/Rund) og "Vælg hoved farve" (2 værdier) er to helt
       ADSKILTE, ikke-sammenlignelige options (form ≠ farve), men blev vist
       under én forkert "Vælg farver — X farver pr. figur · vælg én ad
       gangen"-overskrift, og "Vælg form" kollapsede uden sin egen synlige
       label. Markeres med en egen klasse, så CSS'en kun rammer disse
       fieldsets — ikke enhver .product-form__input_color i pickeren. */
    var colorFieldsets = Array.prototype.slice.call(
      picker.querySelectorAll('fieldset.product-form__input_color:not(.hidden)')
    ).filter(function (fs) {
      if (fs.querySelectorAll('input[type="radio"]').length < 2) return false;
      var label = fs.querySelector('.form__label .text-color-desc');
      var name = label ? label.textContent.toLowerCase() : '';
      return name.indexOf('farve') > -1 || name.indexOf('color') > -1 || name.indexOf('colour') > -1;
    });
    if (colorFieldsets.length < 2) return;
    picker.classList.add('pv27-picker--rows');
    colorFieldsets.forEach(function (fs) { fs.classList.add('pv27-row-fieldset'); });

    function openFirstChecked() {
      var opened = false;
      colorFieldsets.forEach(function (fs) {
        var hasChecked = fs.querySelector('input:checked') !== null;
        fs.classList.toggle('is-open', hasChecked && !opened);
        if (hasChecked && !opened) opened = true;
      });
      if (!opened && colorFieldsets[0]) colorFieldsets[0].classList.add('is-open');
    }
    openFirstChecked();

    function open(fs) {
      colorFieldsets.forEach(function (other) {
        var on = other === fs;
        other.classList.toggle('is-open', on);
        var head = other.querySelector('.form__label');
        if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    colorFieldsets.forEach(function (fs) {
      var head = fs.querySelector('.form__label');
      if (head) {
        head.setAttribute('role', 'button');
        head.setAttribute('tabindex', '0');
        head.setAttribute('aria-expanded', fs.classList.contains('is-open') ? 'true' : 'false');
        head.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          open(fs);
        });
      }
      /* Hele den kollapsede række er klikbar, ikke kun 22 px-overskriften */
      fs.addEventListener('click', function (e) {
        if (fs.classList.contains('is-open')) return;
        e.preventDefault();
        open(fs);
      });
      /* Tastatur: pil/tab ind på en skjult radio åbner rækken, så man ser valget */
      fs.addEventListener('focusin', function (e) {
        if (!fs.classList.contains('is-open') && e.target && e.target.matches && e.target.matches('input[type="radio"]')) open(fs);
      });
    });

    /* Vælges en farve med mus/touch i den ÅBNE række, folder næste række sig
       automatisk ud (ejer-ønske 2026-09-17: kunden skulle ikke selv folde
       "Hjerte" ud efter at have valgt "Krop"). Kort delay så valget er synligt
       FØR rækken lukker. Tastatur (piletaster/mellemrum på en radio) rykker
       ALDRIG videre automatisk — fokus skal blive hos kunden, og skjulte
       radioer i den lukkede næste række må ikke stjæle den.
       Selve radioen er visuelt skjult (.visually-hidden) — det ægte
       pointerdown-mål er den synlige <label class="product__color-swatch">,
       IKKE inputtet selv. Alt uden for .form__label (den kollapsible
       overskrift) tælles som et swatch-valg. */
    var viaPointer = false;
    colorFieldsets.forEach(function (fs) {
      fs.addEventListener('pointerdown', function (e) {
        if (e.target && e.target.closest && e.target.closest('.form__label')) return;
        viaPointer = true;
      });
    });
    colorFieldsets.forEach(function (fs, i) {
      fs.addEventListener('change', function (e) {
        if (!viaPointer || !e.target || !e.target.matches || !e.target.matches('input[type="radio"]')) return;
        viaPointer = false;
        if (!fs.classList.contains('is-open')) return;
        var next = colorFieldsets[i + 1];
        if (!next) return;
        setTimeout(function () { open(next); }, 250);
      });
    });
  })();

  /* ── 3) Variant-kort: prisdelta + valgfri dekoration fra custom.option_meta ──
     JS APPENDER kun børn til temaets egne <label>-elementer og ændrer kun
     label-TEKST — theme.js læser input.value, aldrig label-teksten, og
     pickeren gen-renderes aldrig (se docs/GLOBAL_PRODUKTSIDE_2026_09.md). */
  (function initOptionMeta() {
    var fieldsets = Array.prototype.slice.call(section.querySelectorAll('.pv27-variant-picker fieldset.product-form__input:not(.hidden)'));
    if (!fieldsets.length) return;

    function optionNameOf(fs) {
      var labelSpan = fs.querySelector('.form__label .text-color-desc');
      return labelSpan ? labelSpan.textContent.replace(/:\s*$/, '').trim() : null;
    }
    function valueOf(label) {
      var input = document.getElementById(label.getAttribute('for'));
      return (input && input.value) || label.getAttribute('data-value');
    }

    var meta = null;
    var el = document.getElementById('pv27-option-meta-' + section.getAttribute('data-section'));
    if (el) { try { meta = JSON.parse(el.textContent); } catch (e) { meta = null; } }

    if (meta) fieldsets.forEach(function (fs) {
      var optMeta = meta[optionNameOf(fs)];
      if (!optMeta) return;

      fs.querySelectorAll('label[data-value], label.product__item-option').forEach(function (label) {
        var value = valueOf(label);
        var row = value && optMeta[value];
        if (!row) return;

        var titleEl = label.querySelector('span:not([class^="pv27"])');
        var split = row.bar && titleEl ? titleEl.textContent.trim().match(/^(.+?)\s+-\s+(.+)$/) : null;
        if (row.bar) {
          var bar = document.createElement('span');
          bar.className = 'pv27-bar';
          bar.style.setProperty('--pv27-bar-h', Math.max(10, Math.min(64, row.bar)) + 'px');
          label.insertBefore(bar, label.firstChild);
        }
        /* "Lav - 80 mm" → titel "Lav" + undertekst "80 mm · flade tage" (9a) */
        if (split) titleEl.textContent = split[1];
        var subText = [split ? split[2] : '', row.sub || ''].filter(Boolean).join(' · ');
        if (subText) {
          var sub = document.createElement('span');
          sub.className = 'pv27-sub';
          sub.textContent = subText;
          label.appendChild(sub);
        }
        if (row.recommended) {
          var badge = document.createElement('span');
          badge.className = 'pv27-badge-rec';
          badge.textContent = 'ANBEFALET';
          label.appendChild(badge);
        }
        if (row.hint && fs.querySelector('.pv27-step-hint') === null) {
          var hint = document.createElement('div');
          hint.className = 'pv27-step-hint';
          hint.textContent = row.hint;
          fs.appendChild(hint);
        }
      });
    });

    /* Prisdelta pr. værdi (9a "500 mm · +49 kr"): søskende = varianter der
       matcher den aktuelle variant på ALLE ANDRE options; delta = værdiens
       pris minus den billigste søskende. Kun > 0 vises. */
    function refreshDeltas() {
      var data = getProduct();
      var v = currentVariant();
      if (!data || !data.options || !v) return;
      var opts = data.options.map(function (o, i) { return { name: o, position: i + 1 }; });
      fieldsets.forEach(function (fs) {
        var name = optionNameOf(fs);
        var opt = opts.filter(function (o) { return o.name === name; })[0];
        if (!opt) return;
        var posKey = 'option' + opt.position;
        var siblings = data.variants.filter(function (variant) {
          return opts.every(function (o) {
            var key = 'option' + o.position;
            return o.position === opt.position || variant[key] === v[key];
          });
        });
        if (siblings.length < 2) return;
        var min = Math.min.apply(null, siblings.map(function (s) { return s.price; }));
        fs.querySelectorAll('label[data-value], label.product__item-option').forEach(function (label) {
          var value = valueOf(label);
          var match = siblings.filter(function (s) { return s[posKey] === value; })[0];
          var delta = match ? match.price - min : 0;
          var existing = label.querySelector('.pv27-delta');
          if (delta > 0) {
            if (!existing) { existing = document.createElement('span'); existing.className = 'pv27-delta'; label.appendChild(existing); }
            existing.textContent = '+' + shortMoney(delta);
          } else if (existing) {
            existing.parentNode.removeChild(existing);
          }
        });
      });
    }

    refreshDeltas();
    section.addEventListener('change', refreshDeltas);
  })();

  /* ── 4) Variant-mønstre: swatch-farver, kortnavne, per-figur-hoved ──
     Rører ALDRIG input/fieldset-strukturen (theme.js' updateOptions læser
     alle <fieldset> i DOM-rækkefølge) — kun CSS-variabler, klasser, tekst i
     temaets egen tooltip-span og ét <div>-hoved før per-figur-rækkerne. */
  (function initVariantPatterns() {
    var picker = section.querySelector('.pv27-variant-picker');
    if (!picker) return;
    /* 1) Swatch pr. label. Primær kilde er Liquid-kortet i sektionen
          (--pv27-sw/--pv27-dot sat server-side). Denne JS er kun et
          sikkerhedsnet når variablen mangler, med temaets egen prioritet
          (global.js checkSwatches, som pv26): variantfoto (data-image) →
          native swatch (data-option-swatch-value) → README-farvekort. */
    var FALLBACK = { 'sort': '#1b2430', 'hvid': '#f4f1ea', 'grå': '#8a93a1', 'graa': '#8a93a1', 'orange': '#e8742a', 'brun': '#6b4a2b', 'beige': '#b08968', 'latte brown': '#8a6a44', 'cream': '#ece3d2' };
    function cleanName(v) { return String(v || '').replace(/\s+-\s+[mM]$/, '').trim(); }
    picker.querySelectorAll('label.product__color-swatches--js').forEach(function (label) {
      if (getComputedStyle(label).getPropertyValue('--pv27-sw').trim()) return;
      var raw = (label.getAttribute('data-option-swatch-value') || '').trim();
      var img = (label.getAttribute('data-image') || '').trim();
      var colour = '';
      if (/^url\(/i.test(raw)) colour = raw + ' center / cover';
      else if (raw) colour = raw;
      else colour = FALLBACK[cleanName(label.getAttribute('data-value')).toLowerCase()] || '';
      var sw = img ? 'url("' + img + '") center / cover' : colour;
      if (sw) label.style.setProperty('--pv27-sw', sw);
      if (colour) label.style.setProperty('--pv27-dot', colour);
    });

    /* 2) Kortere, pænere navne i swatch-kortene ("Latte Brown - M" → "Latte Brown").
          Tooltip-spannet læses ikke af theme.js (den læser input.value). */
    picker.querySelectorAll('label.product__color-swatches--js > .tooltip-content').forEach(function (span) {
      span.textContent = cleanName(span.textContent);
    });

    /* 3) Valgt farve pr. fieldset → --pv27-cur-sw (prikken i kollapsede rækker) */
    function syncCurrent() {
      picker.querySelectorAll('fieldset.product-form__input_color').forEach(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        var label = checked && fs.querySelector('label[for="' + checked.id + '"]');
        var sw = label ? swatchFill(label) : '';
        if (sw) fs.style.setProperty('--pv27-cur-sw', sw); else fs.style.removeProperty('--pv27-cur-sw');
        /* theme.js skriver den rå værdi ("Plum - M") i .option_value og læser den aldrig igen */
        var ov = fs.querySelector('.form__label .option_value');
        if (ov && checked) ov.textContent = cleanName(checked.value);
      });
    }
    syncCurrent();
    section.addEventListener('change', syncCurrent);

    /* 4) Per-figur: ét samlet trin-hoved før første række (designets
          "1 · Vælg farver" + "13 farver pr. figur · vælg én ad gangen").
          Kører efter initRowsPattern har sat .pv27-row-fieldset. */
    var rows = picker.querySelectorAll('fieldset.pv27-row-fieldset');
    if (rows.length >= 2 && !picker.querySelector('.pv27-rows-head')) {
      /* Rækkerne har ikke altid lige mange farver (Hjerteformet Boks: top 4 /
         bund 5; Sabre Hjertefigur: krop 7 / hjerte 3) — ens antal ⇒ "N",
         ellers interval, så hint-teksten aldrig påstår et forkert tal. */
      var counts = Array.prototype.map.call(rows, function (r) { return r.querySelectorAll('input[type="radio"]').length; });
      var lo = Math.min.apply(null, counts);
      var hi = Math.max.apply(null, counts);
      var n = lo === hi ? String(lo) : lo + '–' + hi;
      var head = document.createElement('div');
      head.className = 'pv27-rows-head';
      head.innerHTML = '<span class="pv27-rows-head__label">Vælg farver</span><span class="pv27-rows-head__hint"></span>';
      head.querySelector('.pv27-rows-head__hint').textContent = n + ' farver pr. figur · vælg én ad gangen';
      rows[0].parentNode.insertBefore(head, rows[0]);
    }

  })();

  /* ── 5) "Du ser"-pille + køb-bar-resumé (kun valg med flere værdier) ── */
  (function initSelectionSummary() {
    var viewingText = section.querySelector('[data-pv27-viewing-text]');
    var viewingDots = section.querySelector('[data-pv27-viewing-dots]');
    var bar = section.querySelector('[data-pv27-summary]');
    var barText = bar ? bar.querySelector('[data-pv27-summary-text]') : null;
    var barShort = bar ? bar.querySelector('[data-pv27-summary-short]') : null;
    if (!viewingText && !barText) return;

    function choices() {
      var out = { text: [], short: [], colours: [] };
      section.querySelectorAll('.pv27-variant-picker fieldset.product-form__input:not(.hidden)').forEach(function (fs) {
        if (fs.querySelectorAll('input[type="radio"]').length < 2) return;
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        out.text.push(valueLong(checked.value));
        out.short.push(valueShort(checked.value));
        if (!fs.classList.contains('product-form__input_color')) return;
        var fill = swatchFill(labelFor(checked));
        if (fill) out.colours.push(fill);
      });
      return out;
    }
    function paintDots(host, colours, cls, before) {
      if (!host) return;
      Array.prototype.slice.call(host.querySelectorAll('.' + cls)).forEach(function (d) { d.parentNode.removeChild(d); });
      colours.forEach(function (fill) {
        var dot = document.createElement('span');
        dot.className = cls;
        dot.setAttribute('aria-hidden', 'true');
        dot.style.background = fill;
        if (before) host.insertBefore(dot, before); else host.appendChild(dot);
      });
    }

    function refresh() {
      var c = choices();
      if (!c.text.length) {
        var v = currentVariant();
        if (v && v.title && v.title !== 'Default Title') { c.text = v.title.split(' / ').map(valueLong); c.short = v.title.split(' / ').map(valueShort); }
      }
      if (!c.text.length) return;
      var text = c.text.join(' · ');
      if (viewingText) viewingText.textContent = text;
      if (barShort) barShort.textContent = c.short.join(' · ');
      if (barText) {
        barText.textContent = text;
        paintDots(bar, c.colours, 'pv27-buybar__dot', barText);
        bar.classList.toggle('pv27-buybar__summary--stack', c.colours.length > 1);
      }
      paintDots(viewingDots, c.colours, 'pv27-viewing-dot', null);
    }

    section.addEventListener('change', refresh);
    refresh();
  })();

  /* ── 6) Mobil-prisrækken under titlen spejler køb-barens pris ── */
  (function initMobilePrice() {
    var out = section.querySelector('[data-pv27-mprice]');
    var src = section.querySelector('.pv27-buybar .pv27-price');
    if (!out || !src || !('MutationObserver' in window)) return;
    function sync() {
      var p = src.querySelector('.price-regular .price') || src.querySelector('.price');
      var t = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
      if (t) out.textContent = t;
    }
    new MutationObserver(sync).observe(src, { childList: true, subtree: true, characterData: true });
    sync();
  })();

  /* ── 7) Kurv-motor: hero-rækken, bundle-kortet og tilvalg ──
     Hovedproduktet læses på KLIK-tidspunktet fra hovedformularen (variant-id,
     antal, properties[...]) og kun når temaets egen købsknap er aktiv. */
  var PV27_STR = {
    both: '+ Tilføj begge', bothShort: '+ Begge', single: '+ Tilføj',
    added: '✓ Tilføjet', bundleAdded: '✓ Lagt i kurv', unavailable: 'Ikke på lager',
    all: '+ Tilføj alle [n]', allShort: '+ Alle [n]', none: 'Vælg mindst én',
    onlyThis: 'Valgt udgave er ikke på lager – tilføjer kun denne',
    onlyThese: 'Valgt udgave er ikke på lager – tilføjer kun de valgte',
    error: 'Kunne ikke lægge i kurven. Prøv igen.'
  };
  var renderers = [];
  function rerenderAll(reset) { renderers.forEach(function (fn) { fn(reset === true); }); }
  function mainAddButton() { return mainForm ? mainForm.querySelector('[name="add"]') : null; }

  function mainPurchasable() {
    var btn = mainAddButton();
    if (btn && btn.disabled && btn.getAttribute('aria-busy') !== 'true') return false;
    var v = currentVariant();
    return !!(v && v.available);
  }

  function familyValid() {
    var fam = section.querySelector('family-color-selector-element');
    if (!fam || typeof fam.validateBeforeSubmit !== 'function') return true;
    return fam.validateBeforeSubmit();
  }

  function mainLineItem() {
    var id = currentVariantId();
    if (!id) return null;
    var item = { id: id, quantity: currentQty() };
    if (mainForm) {
      var props = {};
      new FormData(mainForm).forEach(function (val, key) {
        if (typeof val !== 'string' || val === '') return;
        if (key.indexOf('properties[') === 0 && key.slice(-1) === ']') props[key.slice(11, -1)] = val;
        else if (key === 'selling_plan') item.selling_plan = parseInt(val, 10);
      });
      if (Object.keys(props).length) item.properties = props;
    }
    return item;
  }

  function getCart() { return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); }

  function updateCartCount() {
    fetch('/cart.json').then(function (r) { return r.json(); }).then(function (c) {
      if (c.item_count === undefined) return;
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.innerHTML = el.classList.contains('cart-count-drawer') ? '(' + c.item_count + ')' : c.item_count > 100 ? '~' : c.item_count;
      });
      var total = document.querySelector('header-total-price');
      if (total && typeof total.updateTotal === 'function') total.updateTotal(c);
    }).catch(function () {});
  }

  function swapCartSections(sections) {
    var cart = getCart();
    if (!cart || !sections || typeof cart.getSectionsToRender !== 'function') return;
    cart.getSectionsToRender().forEach(function (s) {
      var target = document.getElementById(s.id);
      var html = sections[s.id];
      if (!target || !html) return;
      var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
      if (inner) target.innerHTML = inner.innerHTML;
    });
    if (typeof cart.cartAction === 'function') cart.cartAction();
  }

  /* Efter en 422 kan Shopify have lagt en DEL i kurven — hent drawer friskt. */
  function resyncCart() {
    updateCartCount();
    var cart = getCart();
    if (!cart || typeof cart.getSectionsToRender !== 'function') return;
    var ids = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(swapCartSections).catch(function () {});
  }

  function showAddError(scope, message) {
    if (!scope) return;
    var el = scope.querySelector('[data-pv27-add-error]');
    if (el) { el.textContent = message || ''; el.hidden = !message; return; }
    var wrap = scope.querySelector('.product-form__error-message-wrapper');
    var msg = wrap && wrap.querySelector('.product-form__error-message');
    if (msg) { msg.textContent = message || ''; wrap.hidden = !message; }
  }

  function addItems(items, trigger, scope) {
    var cart = getCart();
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (trigger) { trigger.disabled = true; trigger.setAttribute('aria-busy', 'true'); trigger.classList.add('loading'); }
    showAddError(scope, '');
    var sectionIds = cart && typeof cart.getSectionsToRender === 'function' ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds, sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (body) {
          if (!r.ok || body.status || body.errors) { var err = new Error(body.description || body.message || ''); err.pv27Cart = true; throw err; }
          return body;
        });
      })
      .then(function (res) {
        updateCartCount();
        if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return false; }
        swapCartSections(res.sections);
        if (typeof cart.open === 'function') cart.open();
        return true;
      })
      .catch(function (err) {
        showAddError(scope, (err && err.pv27Cart && err.message) || PV27_STR.error);
        resyncCart();
        return false;
      })
      .then(function (ok) {
        if (trigger) { trigger.disabled = false; trigger.removeAttribute('aria-busy'); trigger.classList.remove('loading'); }
        return ok;
      });
  }

  /* "A", "A og B", "A, B og C" */
  function joinNames(names) {
    if (names.length < 2) return names.join('');
    return names.slice(0, -1).join(', ') + ' og ' + names[names.length - 1];
  }

  /* Hero-rækken "Ofte købt sammen med": 1–3 produkter (snippets/
     product-global-block.liquid → complementary_row). Hvert produkt er et
     [data-pv27-comp-item] med variant + pris i data-attributter eller en
     <select> (flere varianter) og — når der er flere — en afkrydsning.
     [data-pv27-comp-pick] (familiefigurer, covers) lægges aldrig i kurven. */
  function bindCompRow(row) {
    var btn = row.querySelector('[data-pv27-add-comp]');
    if (!btn || btn.hasAttribute('data-pv27-bound')) return null;
    btn.setAttribute('data-pv27-bound', '');
    var comps = Array.prototype.slice.call(row.querySelectorAll('[data-pv27-comp-item]:not([data-pv27-comp-pick])')).map(function (li) {
      var check = li.querySelector('[data-pv27-comp-check]');
      var select = li.querySelector('[data-pv27-comp-select]');
      return {
        title: li.getAttribute('data-title') || '',
        priceEl: li.querySelector('[data-pv27-comp-item-price]'),
        checked: function () { return !check || check.checked; },
        id: function () { return parseInt(select ? select.value : li.getAttribute('data-variant'), 10) || 0; },
        price: function () {
          var opt = select && select.options[select.selectedIndex];
          return parseInt(opt ? opt.getAttribute('data-price') : li.getAttribute('data-price'), 10) || 0;
        }
      };
    });
    if (!comps.length) return null;
    var hint = row.querySelector('[data-pv27-comp-hint]');
    var added = false;

    function chosen() { return comps.filter(function (c) { return c.checked() && c.id(); }); }

    /* Afkrydsning og variant-vælger her må ikke nå sektionens change-lyttere
       (de gælder hovedproduktets vælger) — rækken genberegner selv. */
    row.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest('[data-pv27-comp-item]')) return;
      e.stopPropagation();
      render(true);
    });

    function setLabel(long, short) {
      btn.textContent = '';
      [['pv27-lbl--long', long], ['pv27-lbl--short', short]].forEach(function (pair) {
        var s = document.createElement('span');
        s.className = 'pv27-lbl ' + pair[0];
        s.textContent = pair[1];
        btn.appendChild(s);
      });
    }

    function render(reset) {
      comps.forEach(function (c) { if (c.priceEl) c.priceEl.textContent = shortMoney(c.price()); });
      if (reset) added = false;
      if (added) return;
      btn.classList.remove('is-added');
      var picked = chosen();
      if (btn.getAttribute('aria-busy') !== 'true') btn.disabled = !picked.length;
      if (!picked.length) {
        setLabel(PV27_STR.none, PV27_STR.none);
        btn.removeAttribute('aria-label');
        if (hint) hint.hidden = true;
        return;
      }
      var sum = picked.reduce(function (s, c) { return s + c.price(); }, 0);
      var names = joinNames(picked.map(function (c) { return c.title; }));
      var v = currentVariant(), qty = currentQty(), p = getProduct();
      if (mainPurchasable() && v) {
        var total = v.price * qty + sum;
        var count = picked.length + 1;
        if (count > 2) {
          setLabel(PV27_STR.all.replace('[n]', count) + ' · ' + shortMoney(total), PV27_STR.allShort.replace('[n]', count) + ' · ' + shortMoney(total));
        } else {
          setLabel(PV27_STR.both + ' · ' + shortMoney(total), PV27_STR.bothShort + ' · ' + shortMoney(total));
        }
        btn.setAttribute('aria-label', 'Læg ' + (qty > 1 ? qty + ' × ' : '') + (p ? p.title : 'produktet') + ' og ' + names + ' i kurven, i alt ' + money(total));
        if (hint) hint.hidden = true;
      } else {
        setLabel(PV27_STR.single + ' · ' + shortMoney(sum), '+ ' + shortMoney(sum));
        btn.setAttribute('aria-label', 'Læg kun ' + names + ' i kurven, ' + money(sum));
        if (hint) { hint.textContent = picked.length > 1 ? PV27_STR.onlyThese : PV27_STR.onlyThis; hint.hidden = false; }
      }
    }

    btn.addEventListener('click', function () {
      var picked = chosen();
      if (!picked.length || btn.disabled) return;
      /* Shopify viser den SIDSTE linje i en /cart/add-request øverst i kurven —
         derfor kommer det viste produkt til sidst, så det står først i drawer'en */
      var items = picked.map(function (c) { return { id: c.id(), quantity: 1 }; });
      if (mainPurchasable()) {
        if (!familyValid()) return;
        var main = mainLineItem();
        if (main) items.push(main);
      }
      addItems(items, btn, row).then(function (ok) {
        if (!ok) return;
        added = true;
        btn.classList.add('is-added');
        setLabel(PV27_STR.added, PV27_STR.added);
        btn.setAttribute('aria-label', PV27_STR.added);
      });
    });

    render(true);
    return render;
  }

  function bindBundle(card) {
    var btn = card.querySelector('[data-pv27-add-bundle]');
    var totalEl = card.querySelector('[data-pv27-bundle-total]');
    var mainSub = card.querySelector('[data-pv27-bundle-main-sub]');
    var scope = card.closest('.pv27-row__body') || card;
    var extras = Array.prototype.slice.call(card.querySelectorAll('[data-pv27-bundle-item]')).map(function (el) {
      return { id: parseInt(el.getAttribute('data-pv27-bundle-item'), 10), price: parseInt(el.getAttribute('data-price'), 10) || 0 };
    }).filter(function (x) { return !!x.id; });
    var ctaText = btn ? (btn.getAttribute('data-pv27-cta') || btn.textContent.trim()) : '';
    var added = false;

    function render(reset) {
      if (reset) added = false;
      var v = currentVariant(), qty = currentQty();
      if (v) {
        var total = v.price * qty;
        extras.forEach(function (x) { total += x.price; });
        if (totalEl) totalEl.textContent = money(total);
        if (mainSub) {
          var parts = [];
          if (v.title && v.title !== 'Default Title') parts.push(v.title.split(' / ').join(' · '));
          parts.push((qty > 1 ? qty + ' × ' : '') + money(v.price));
          mainSub.textContent = parts.join(' · ');
        }
      }
      if (!btn || added) return;
      btn.classList.remove('is-added');
      var ok = mainPurchasable();
      btn.disabled = !ok;
      btn.textContent = ok ? ctaText : PV27_STR.unavailable;
    }

    if (btn) btn.addEventListener('click', function () {
      if (btn.disabled || !mainPurchasable() || !extras.length) return;
      if (!familyValid()) return;
      var main = mainLineItem();
      if (!main) return;
      var items = extras.map(function (x) { return { id: x.id, quantity: 1 }; }).concat([main]);
      addItems(items, btn, scope).then(function (ok) {
        if (!ok) { render(false); return; }
        added = true;
        btn.classList.add('is-added');
        btn.textContent = PV27_STR.bundleAdded;
      });
    });

    render(true);
    return render;
  }

  section.addEventListener('change', function () { setTimeout(function () { rerenderAll(true); }, 0); });
  section.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') rerenderAll(true); });
  section.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.quantity__button')) setTimeout(function () { rerenderAll(true); }, 60);
  });
  (function watchMainAddButton() {
    var btn = mainAddButton();
    if (!btn || !('MutationObserver' in window)) return;
    new MutationObserver(function () { rerenderAll(false); }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
  })();
  section.querySelectorAll('[data-pv27-comp-row]').forEach(function (row) { var r = bindCompRow(row); if (r) renderers.push(r); });
  section.querySelectorAll('[data-pv27-bundle]').forEach(function (card) { renderers.push(bindBundle(card)); });

  /* ── 7b) Købsbaren følger med ned ad siden (≥768px) ──
     Baren bor i DOM'en lige under heroen (kan flyttes i Theme Editor). CSS
     sticky holder den i bunden af vinduet, så længe dens plads ligger UNDER
     skærmen. Når pladsen er rullet op forbi toppen, lægges baren fixed i
     bunden (en usynlig .pv27-buybar-slot holder pladsen, så intet hopper),
     og når sektionens slutning kommer til syne, dokker den i bunden af
     .pv27-scroll i stedet for at ligge oven på footeren. */
  (function initFloatingBar() {
    var bar = section.querySelector('[data-pv27-buybar]');
    var scroller = section.querySelector('.pv27-scroll');
    if (!bar || !scroller || !window.matchMedia || !bar.parentNode) return;
    var mq = window.matchMedia('(min-width: 768px)');
    var slot = document.createElement('div');
    slot.className = 'pv27-buybar-slot';
    slot.setAttribute('aria-hidden', 'true');
    bar.parentNode.insertBefore(slot, bar);
    var state = '';
    var ticking = false;

    function set(next) {
      if (next === state) return;
      state = next;
      bar.classList.toggle('is-floating', next === 'float');
      bar.classList.toggle('is-docked-end', next === 'end');
      slot.classList.toggle('is-active', next !== '');
    }

    function headerBottom() {
      var hdr = document.querySelector('.header-v2');
      if (!hdr) return 0;
      var b = hdr.getBoundingClientRect().bottom;
      return b > 0 && b < window.innerHeight / 2 ? b : 0;
    }

    function measure() {
      ticking = false;
      if (!mq.matches) {
        set('');
        scroller.style.paddingBottom = '';
        return;
      }
      var h = bar.offsetHeight;
      if (state === '') slot.style.height = h + 'px';
      scroller.style.paddingBottom = h + 'px';
      var home = (state === '' ? bar : slot).getBoundingClientRect();
      if (home.top >= headerBottom()) { set(''); return; }
      set(scroller.getBoundingClientRect().bottom <= window.innerHeight ? 'end' : 'float');
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    if (mq.addEventListener) mq.addEventListener('change', request);
    measure();
  })();

  /* ── 8) Tilvalg: valgt kit lægges i kurven som linje 2 (samme greb som
     main-product-loopy.js §8 — capture-fase, kun når et kit er valgt) ── */
  (function initAddon() {
    var group = section.querySelector('[data-pv27-addons]');
    if (!group || !mainForm) return;
    var cards = Array.prototype.slice.call(group.querySelectorAll('.pv27-addon-card'));
    var state = { id: null, price: 0 };
    var barAddon = section.querySelector('[data-pv27-addon-summary]');
    var priceNode = section.querySelector('.pv27-price .price-regular .price');

    /* Tilvalgets pris er IKKE en rabat/merpris på hovedvarianten — det er en
       helt separat variant (LED Lampe Kit) der lægges i kurven som linje 2.
       theme.js' updatePrice() kender intet til den og skriver kun
       hovedvariantens egen pris ind i knuden ved hvert variantskift, så vi
       skal selv lægge tilvalgsprisen oveni her, hver gang valget ELLER
       hovedvarianten ændrer sig. */
    function updatePriceDisplay() {
      if (!priceNode) return;
      var v = currentVariant();
      var base = v ? v.price : 0;
      priceNode.textContent = money(base + state.price);
    }

    function select(card) {
      if (!card) return;
      cards.forEach(function (c) { c.setAttribute('aria-pressed', c === card ? 'true' : 'false'); });
      state.id = parseInt(card.getAttribute('data-pv27-addon-variant'), 10) || null;
      state.price = parseInt(card.getAttribute('data-pv27-addon-price'), 10) || 0;
      if (barAddon) {
        var name = state.id ? card.getAttribute('data-pv27-addon-name') : '';
        barAddon.textContent = name ? '+ ' + name : '';
        barAddon.hidden = !name;
      }
      updatePriceDisplay();
    }
    cards.forEach(function (card) { card.addEventListener('click', function () { select(card); }); });
    select(group.querySelector('.pv27-addon-card[aria-pressed="true"]') || cards[0]);
    /* 'change' bobler op gennem variant-radios-detail (som allerede har
       skrevet den nøgne hovedpris) FØR den når section — samme rækkefølge-
       garanti som initSelectionSummary ovenfor bruger. */
    section.addEventListener('change', updatePriceDisplay);
    mainForm.addEventListener('submit', function (e) {
      if (!state.id) return; /* intet kit: temaets product-form kører uændret */
      e.preventDefault();
      e.stopImmediatePropagation();
      var submit = mainForm.querySelector('[name="add"]');
      if (submit && submit.disabled) return;
      if (!familyValid()) return;
      var main = mainLineItem();
      if (!main) return;
      addItems([{ id: state.id, quantity: main.quantity }, main], submit, section.querySelector('[data-pv27-buybar]'));
    }, true);
  })();


  /* ── 8b) Resumé i desktop-baren for produkter uden valg (8a/7b) ──
     8a: "XPENG G6 · Type 2 · 1 stk" (passer-til-kortene + antal).
     7b: "Månelampe · egen lyskilde" (produkt + tilvalg). Skjult på mobil. */
  (function initBaseSummary() {
    var wrap = section.querySelector('[data-pv27-base-summary]');
    var out = wrap && wrap.querySelector('[data-pv27-base-text]');
    if (!out) return;
    var data = getProduct();
    var fits = Array.prototype.slice.call(section.querySelectorAll('.pv27-fit-card__title'))
      .map(function (el) { return el.textContent.replace(/\s+/g, ' ').trim(); })
      .filter(Boolean).slice(0, 2);
    var base = fits.length ? fits.join(' · ') : ((data && data.title) || out.textContent.trim());
    var addons = section.querySelector('[data-pv27-addons]');
    function render() {
      var tail;
      if (addons) {
        var pressed = addons.querySelector('.pv27-addon-card[aria-pressed="true"]');
        var name = pressed ? (pressed.getAttribute('data-pv27-addon-name') || '') : '';
        if (!name && pressed) {
          var n = pressed.querySelector('.pv27-addon-card__name');
          name = n ? n.textContent.trim().toLowerCase() : '';
        }
        tail = name;
      } else {
        tail = currentQty() + ' stk';
      }
      out.textContent = tail ? base + ' · ' + tail : base;
      wrap.hidden = false;
    }
    section.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.pv27-addon-card, .quantity__button')) setTimeout(render, 60);
    });
    section.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') render(); });
    section.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') render(); });
    render();
  })();

  /* ── 9) Anmeldelser: ÆGTE Judge.me-data ──
     Kilde 1: appens inline-datablok jdgm.data.reviewWidget[<produkt-id>]
     (histogram + første side, 5 stk — erstattes aldrig af Vue-widget'en).
     Kilde 2: samme endpoint som widget'en selv paginerer mod
     (api.judge.me/reviews/reviews_for_widget, CORS *, max 30 pr. side) —
     hentes lazy, så chip-tællerne ("Med billede (2)") er rigtige.
     Alt bygges med textContent (ingen innerHTML af kundetekst). */
  (function initReviews() {
    var wrap = section.querySelector('[data-pv27-reviews]');
    if (!wrap) return;

    var productId = String(wrap.getAttribute('data-product-id') || '');
    var shopDomain = wrap.getAttribute('data-shop-domain') || '';
    var serverCount = parseInt(wrap.getAttribute('data-count'), 10) || 0;
    var chipsEl = wrap.querySelector('[data-pv27-chips]');
    var cardsEl = wrap.querySelector('[data-pv27-review-cards]');
    var moreEl = wrap.querySelector('[data-pv27-show-all-wrap]');
    var widgetEl = wrap.querySelector('[data-pv27-widget]');
    var scratch = document.implementation.createHTMLDocument('');
    var state = { s: null, mode: 'all', expanded: false };

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function stripHtml(html) {
      var d = scratch.createElement('div');
      d.innerHTML = html || '';
      return (d.textContent || '').replace(/\s+/g, ' ').trim();
    }
    function picUrls(list) {
      var out = [];
      (list || []).forEach(function (pic) {
        var url = typeof pic === 'string' ? pic : (pic && (pic.small || pic.compact || pic.original || pic.huge));
        if (url) out.push(url);
      });
      return out;
    }
    function mapReview(r) {
      var v = r.verified_buyer;
      return {
        score: parseFloat(r.rating) || 0,
        verified: v === true || v === 'true' || v === 'True',
        author: (r.reviewer_name || '').trim(),
        variant: (r.product_variant_title || '').trim(),
        title: (r.title || '').trim(),
        body: (r.body != null ? String(r.body).replace(/\s+/g, ' ') : stripHtml(r.body_html)).trim(),
        date: r.created_at || '',
        replier: r.shop_reply_name || '',
        reply: r.reply_content ? stripHtml(r.reply_content) : '',
        pics: picUrls(r.pictures_urls)
      };
    }
    /* Total = sum af histogrammet (samme kilde som tællerne — metafeltet kan halte) */
    function summarize(data) {
      var bars = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }, total = 0;
      (data.histogram || []).forEach(function (row) {
        var f = parseInt(row.frequency, 10) || 0;
        bars[row.rating] = f;
        total += f;
      });
      if (!total) total = parseInt(data.number_of_reviews, 10) || 0;
      return { total: total, bars: bars, reviews: (data.reviews || []).map(mapReview), complete: false };
    }
    function readInline() {
      var store = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
      var data = store && productId ? store[productId] : null;
      return data ? summarize(data) : null;
    }
    function fetchAll() {
      if (!shopDomain || !productId || !window.fetch || !window.Promise) return Promise.reject(new Error('no-fetch'));
      var host = String((window.jdgm && window.jdgm.API_HOST) || 'https://api.judge.me').replace(/\/+$/, '') + '/';
      var base = host + 'reviews/reviews_for_widget?platform=shopify&per_page=30' +
        '&url=' + encodeURIComponent(shopDomain) + '&shop_domain=' + encodeURIComponent(shopDomain) +
        '&product_id=' + encodeURIComponent(productId) + '&page=';
      function page(n) {
        return fetch(base + n, { credentials: 'omit' }).then(function (r) {
          if (!r.ok) throw new Error('judgeme ' + r.status);
          return r.json();
        });
      }
      return page(1).then(function (first) {
        var out = summarize(first);
        var pages = Math.min((first.pagination && first.pagination.total_pages) || 1, 5);
        var rest = [];
        for (var p = 2; p <= pages; p++) rest.push(page(p));
        return Promise.all(rest).then(function (more) {
          more.forEach(function (d) { out.reviews = out.reviews.concat((d.reviews || []).map(mapReview)); });
          out.complete = out.reviews.length >= out.total;
          return out;
        });
      });
    }

    function relDate(iso) {
      var t = Date.parse(iso);
      if (isNaN(t)) return '';
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var then = new Date(t); then.setHours(0, 0, 0, 0);
      var days = Math.round((today - then) / 86400000);
      if (days < 1) return 'i dag';
      if (days < 2) return 'i går';
      if (days < 7) return 'for ' + days + ' dage siden';
      if (days < 30) { var w = Math.floor(days / 7); return 'for ' + w + (w === 1 ? ' uge' : ' uger') + ' siden'; }
      if (days < 365) { var m = Math.floor(days / 30); return 'for ' + m + (m === 1 ? ' måned' : ' måneder') + ' siden'; }
      var y = Math.floor(days / 365);
      return 'for ' + y + ' år siden';
    }
    function starsEl(score, cls) {
      var s = el('span', cls);
      var full = Math.round(score);
      s.setAttribute('role', 'img');
      s.setAttribute('aria-label', full + ' ud af 5 stjerner');
      for (var i = 1; i <= 5; i++) {
        var star = el('span', i <= full ? 'is-full' : '', '★');
        star.setAttribute('aria-hidden', 'true');
        s.appendChild(star);
      }
      return s;
    }
    function firstOption(r) { return r.variant ? r.variant.split(/\s*\/\s*/)[0] : ''; }
    function hasText(r) { return !!(r.title || r.body); }

    function renderSummary(s) {
      var barsEl = wrap.querySelector('[data-pv27-bars]');
      if (!barsEl || s.total < 2) return;
      barsEl.querySelectorAll('[data-pv27-bar]').forEach(function (row) {
        var star = row.getAttribute('data-pv27-bar');
        var n = s.bars[star] || 0;
        row.querySelector('[data-pv27-bar-fill]').style.width = Math.round((n / s.total) * 100) + '%';
        row.querySelector('[data-pv27-bar-count]').textContent = String(n);
        row.setAttribute('aria-label', star + ' stjerner: ' + n);
      });
      barsEl.hidden = false;
      var share = wrap.querySelector('[data-pv27-share]');
      if (share) {
        share.textContent = ' · ' + Math.round(((s.bars[5] + s.bars[4]) / s.total) * 100) + ' % giver 4–5 stjerner';
        share.hidden = false;
      }
    }

    function visibleRows() {
      var s = state.s;
      if (state.mode === 'pics') return s.reviews.filter(function (r) { return r.pics.length; });
      /* tomme stjerne-anmeldelser (ingen titel/tekst) giver tomme kort — springes over */
      var list = s.reviews.filter(hasText);
      if (state.mode === 'newest') {
        list.sort(function (a, b) { return (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0); });
      } else if (state.mode.indexOf('v:') === 0) {
        var v = state.mode.slice(2);
        list = list.filter(function (r) { return firstOption(r) === v; });
      }
      return list;
    }

    function renderChips() {
      var s = state.s;
      if (!chipsEl || !s.complete || s.total < 2) { if (chipsEl) chipsEl.hidden = true; return; }
      var picCount = s.reviews.filter(function (r) { return r.pics.length; }).length;
      var defs = [{ key: 'all', label: 'Alle (' + s.total + ')' }];
      if (picCount) defs.push({ key: 'pics', label: 'Med billede (' + picCount + ')' });
      var prod = getProduct();
      if (prod && prod.variants && prod.variants.length > 1) {
        var counts = {}, best = '';
        s.reviews.forEach(function (r) { var k = firstOption(r); if (k) counts[k] = (counts[k] || 0) + 1; });
        Object.keys(counts).forEach(function (k) { if (!best || counts[k] > counts[best]) best = k; });
        if (best && counts[best] >= 2) defs.push({ key: 'v:' + best, label: best + ' (' + counts[best] + ')' });
      }
      defs.push({ key: 'newest', label: 'Nyeste først' });
      chipsEl.textContent = '';
      defs.forEach(function (d) {
        var b = el('button', 'pv27-chip-btn' + (state.mode === d.key ? ' is-active' : ''), d.label);
        b.type = 'button';
        b.setAttribute('aria-pressed', state.mode === d.key ? 'true' : 'false');
        b.addEventListener('click', function () { state.mode = d.key; renderChips(); renderCards(); });
        chipsEl.appendChild(b);
      });
      chipsEl.hidden = false;
    }

    function cardEl(r) {
      var c = el('article', 'pv27-review-card');
      var head = el('div', 'pv27-review-card__head');
      head.appendChild(starsEl(r.score, 'pv27-review-card__stars'));
      head.appendChild(el('span', 'pv27-review-card__date', relDate(r.date)));
      c.appendChild(head);
      if (hasText(r)) {
        var text = el('div', 'pv27-review-card__text');
        if (r.title) text.appendChild(el('h3', 'pv27-review-card__title', r.title));
        if (r.body && r.body !== r.title) text.appendChild(el('p', 'pv27-review-card__body', r.body));
        c.appendChild(text);
      }
      if (r.pics.length) {
        var img = el('img', 'pv27-review-card__pic');
        img.src = r.pics[0]; img.alt = ''; img.loading = 'lazy'; img.width = 72; img.height = 72;
        c.appendChild(img);
      }
      if (r.reply) {
        var rep = el('div', 'pv27-review-card__reply');
        rep.appendChild(el('span', 'pv27-review-card__reply-name', 'Svar fra ' + (r.replier || 'JM Dimensions')));
        rep.appendChild(el('p', 'pv27-review-card__reply-body', r.reply));
        c.appendChild(rep);
      }
      var foot = el('div', 'pv27-review-card__foot');
      var row = el('div', 'pv27-review-card__foot-row');
      row.appendChild(el('span', 'pv27-review-card__author', r.author || 'Kunde'));
      if (r.verified) row.appendChild(el('span', 'pv27-review-card__verified', '✔ Verificeret køb'));
      foot.appendChild(row);
      if (r.variant) foot.appendChild(el('span', 'pv27-review-card__variant', 'Købte: ' + r.variant.replace(/\s*\/\s*/g, ' · ')));
      c.appendChild(foot);
      return c;
    }

    function renderCards() {
      if (!cardsEl) return;
      var rows = visibleRows();
      var max = serverCount === 1 ? 1 : (state.expanded ? rows.length : 3);
      cardsEl.textContent = '';
      rows.slice(0, max).forEach(function (r) { cardsEl.appendChild(cardEl(r)); });
      cardsEl.hidden = !cardsEl.children.length;
      if (moreEl) moreEl.hidden = state.expanded || serverCount < 2 || rows.length <= cardsEl.children.length;
    }

    function apply(s) {
      if (!s || !s.total) return; /* 0 anmeldelser: kun opsummerings-kortet (README) */
      if (state.s && s.reviews.length < state.s.reviews.length) return; /* aldrig nedgradér */
      state.s = s;
      renderSummary(s);
      renderChips();
      renderCards();
    }

    if (serverCount > 0) {
      apply(readInline());
      var load = function () { fetchAll().then(apply).catch(function () {}); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
        }, { rootMargin: '600px 0px' });
        io.observe(wrap);
      } else {
        load();
      }
    }

    var showAllBtn = wrap.querySelector('[data-pv27-show-all]');
    if (showAllBtn) {
      showAllBtn.addEventListener('click', function () {
        if (state.s && state.s.complete) { state.expanded = true; renderCards(); return; }
        if (moreEl) moreEl.hidden = true;
        if (cardsEl) cardsEl.hidden = true;
        if (chipsEl) chipsEl.hidden = true;
        if (widgetEl) {
          widgetEl.hidden = false;
          window.requestAnimationFrame(function () { widgetEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        }
      });
    }

    var writeBtn = wrap.querySelector('[data-pv27-write-review]');
    if (writeBtn) {
      /* Klik Judge.me's EGEN skriv-knap (formularen er deres modal). Widget'en
         forbliver skjult, og siden hopper aldrig — findes knappen ikke
         (fx empty_state = hide_widget ved 0 anmeldelser), sker der intet. */
      writeBtn.addEventListener('click', function () {
        var target = document.querySelector('.jm-action-buttons__button') || document.querySelector('.jdgm-write-rev-link');
        if (target) target.click();
      });
    }
  })();

  /* ── 10) Komplementær-berigelse: fylder hero-rækken hvis serveren intet havde ── */
  (function initComplementary() {
    var data = getProduct();
    var anchor = section.querySelector('.pv27-steps');
    if (!data || !anchor || section.querySelector('[data-pv27-comp-row]')) return;
    fetch('/recommendations/products?section_id=pv27-complementary&product_id=' + data.id + '&intent=complementary&limit=4')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        /* Kun et produkt, der kan lægges i kurven med ét tryk: på lager, én
           variant og ikke noget der skal sættes op (familiefigur, cover). */
        var item = Array.prototype.slice.call(new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-pv27-comp]')).filter(function (el) {
          return el.getAttribute('data-available') === 'true' && el.getAttribute('data-single') === 'true';
        })[0];
        if (!item) return;
        var url = item.getAttribute('data-url') || '#';
        var title = item.getAttribute('data-title') || '';
        var row = document.createElement('div');
        row.className = 'pv27-comp-row';
        row.setAttribute('data-pv27-comp-row', '');
        row.innerHTML = '<ul class="pv27-comp-row__list" role="list"><li class="pv27-comp-item" data-pv27-comp-item><a class="pv27-comp-row__thumb" tabindex="-1" aria-hidden="true"></a><div class="pv27-comp-row__text"><span class="pv27-comp-row__label">Ofte købt sammen med</span><a class="pv27-comp-row__title"></a><span class="pv27-comp-row__hint" data-pv27-comp-hint hidden></span></div></li></ul><button type="button" class="pv27-comp-row__btn" data-pv27-add-comp></button><p class="pv27-comp-row__error" data-pv27-add-error role="alert" hidden></p>';
        var li = row.querySelector('[data-pv27-comp-item]');
        li.setAttribute('data-variant', item.getAttribute('data-variant-id') || '');
        li.setAttribute('data-price', item.getAttribute('data-price') || '0');
        li.setAttribute('data-title', title);
        var thumb = row.querySelector('.pv27-comp-row__thumb');
        thumb.href = url;
        if (item.getAttribute('data-img')) {
          var img = document.createElement('img');
          img.className = 'pv27-comp-row__img'; img.src = item.getAttribute('data-img'); img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy';
          thumb.appendChild(img);
        }
        var t = row.querySelector('.pv27-comp-row__title');
        t.href = url; t.textContent = title;
        anchor.insertBefore(row, anchor.querySelector(':scope > .pv27-facts-grid'));
        var r = bindCompRow(row);
        if (r) renderers.push(r);
      })
      .catch(function () {});
  })();

  /* ── 11) FAQ: åbne rækker på desktop, accordion med første åben på mobil ── */
  (function initFaqMobile() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
    section.querySelectorAll('.pv27-faq').forEach(function (faq) {
      faq.querySelectorAll('.pv27-faq__item').forEach(function (d, i) { if (i > 0) d.removeAttribute('open'); });
    });
  })();

  /* ── 12) Vagt mod pris-kollision fra "recently viewed"-gitteret ──
     recently_viewed-blokken (delegeret til product-2026-block) injicerer
     RIGTIGE product-item-kort (samme snippets/price-markup, ".price-regular
     .price") i #jmd-v2-rv-grid — som ligger INDE i samme .product__item-js-
     scope som vores egen variant-picker. Temaets VariantRadiosDetail.
     updatePrice() (theme.js, uændret) finder sin pris-boks via
     `productTarget.querySelector(".price-regular .price")` — UDEN id/data-
     scoping — og skriver til den FØRSTE match i DOM-rækkefølge. Da gitteret
     ligger FØR køb-baren i markup'et, "stjæler" et tilfældigt andet produkts
     kort prisopdateringen, og vores egen store pris fryser permanent på
     serverens startværdi. Løsning: omdøb ".price-regular" på indsatte korts
     pris-wrapper (ingen global baseline-styling på den klasse — verificeret,
     kun scopede overrides andre steder i temaet — så intet visuelt ændres)
     så querySelector aldrig matcher dem. */
  (function initRecentlyViewedPriceGuard() {
    var grid = document.getElementById('jmd-v2-rv-grid');
    if (!grid) return;

    function guard(node) {
      if (!node || node.nodeType !== 1) return;
      var wraps = [];
      if (node.classList && node.classList.contains('price-regular')) wraps.push(node);
      if (node.querySelectorAll) {
        wraps = wraps.concat(Array.prototype.slice.call(node.querySelectorAll('.price-regular')));
      }
      wraps.forEach(function (el) {
        el.classList.remove('price-regular');
        el.classList.add('pv27-rv-price-regular');
      });
    }

    guard(grid);
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, guard);
      });
    });
    mo.observe(grid, { childList: true, subtree: true });
  })();
})();
